export default __webpack_public_path__ + "2b08a20be01a1b192d2e319d5d42cbaf.woff2";